import {IconButton, Theme, useTheme} from "@mui/material";
import React from "react";
import {SxProps} from "@mui/system";
import DeleteIcon from "@mui/icons-material/Delete";

export function DeleteIconButton(props: {
  onClick: () => void,
  sx?: SxProps<Theme>,
}) {
  const theme = useTheme();
  return (
    <IconButton size="large" aria-label="delete" onClick={props.onClick} sx={props.sx ? props.sx : {color: theme.palette.error.light}}>
      <DeleteIcon/>
    </IconButton>
  );
}
